import { Icon } from "@core/icons";
import { RFieldGroup } from "./RFieldGroup";
import { FieldError } from "./FormLayout";
import { inputStyle } from "./FormField";
import type { ContentLanguage } from "./LanguageSwitch";
import type { IncludeItem } from "./useIncludesField";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el repetidor bilingüe de
// "Qué incluye" (lista + agregar/quitar elemento) era el mismo marcado
// palabra por palabra en benefits/BenefitsScreen.tsx y
// offers/OffersScreen.tsx — solo el rótulo y el hint del `RFieldGroup`
// contenedor difieren entre las dos pantallas, y viajan como prop.
// Extracción sin cambio de comportamiento ni de valores visuales: ninguna
// pantalla que la use cambia un pixel por esto.
//
// T5 intento 2 (qa-bug-matrix-2026-09.md §4.1, #17; dup:check cruzó el
// umbral con el `FieldError` de `errors.includes` repetido palabra por
// palabra en BenefitsScreen.tsx y OffersScreen.tsx tras el arreglo de T2/T5):
// el `error` opcional completa la extracción de GATE-01-A en vez de romper
// su simetría — el componente compartido pasa a ser dueño también de su
// propio mensaje de validación, en el mismo lugar y con la misma primitiva.
export function IncludesFieldGroup({
  label,
  hint,
  items,
  language,
  onAdd,
  onRemove,
  onUpdate,
  error,
}: {
  label: string;
  hint: string;
  items: IncludeItem[];
  language: ContentLanguage;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onUpdate: (index: number, field: "textEs" | "textEn", value: string) => void;
  error?: string | undefined;
}) {
  return (
    <>
      <RFieldGroup label={label} hint={hint}>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {items.map((item, index) => (
            <div
              key={index}
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <input
                value={language === "es" ? item.textEs : item.textEn}
                onChange={(event) =>
                  onUpdate(
                    index,
                    language === "es" ? "textEs" : "textEn",
                    event.target.value,
                  )
                }
                placeholder={
                  language === "en"
                    ? "Sin traducir · se mostrará en español"
                    : undefined
                }
                style={inputStyle}
                aria-label={`Elemento ${String(index + 1)} de qué incluye`}
              />
              <button
                type="button"
                className="chip"
                style={{ flex: "none", padding: "9px 12px" }}
                onClick={() => onRemove(index)}
                aria-label={`Quitar elemento ${String(index + 1)} de qué incluye`}
              >
                <Icon name="x" size={14} stroke={1.6} />
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          className="chip"
          style={{ marginTop: items.length ? 8 : 0 }}
          onClick={onAdd}
        >
          <Icon name="plus" size={14} /> Agregar elemento
        </button>
      </RFieldGroup>
      {error ? <FieldError message={error} /> : null}
    </>
  );
}
